import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MenuStateService } from 'src/app/menu-state.service';

@Component({
  selector: 'app-menu-manager-modal',
  templateUrl: './menu-manager-modal.component.html',
  styleUrls: ['./menu-manager-modal.component.scss']
})
export class MenuManagerModalComponent implements OnInit {

  modalTitle: string;
  modalMessage: any;
  sideMenuForm: FormGroup;
  sideSubMenuForm: FormGroup;
  sideSubSubMenuForm: FormGroup;
  parentSubMenu: any[] = [];
  parentSubSubMenu: any[] = [];
  saving = false;
  errorMessage = '';
  themeMode: 'light' | 'dark' = 'light';

  constructor(
    public dialogRef: MatDialogRef<MenuManagerModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private http: HttpClient,
    private toastr: ToastrService,
    private menuStateService: MenuStateService,
  ) {
    this.modalTitle = data.data.modalTitle;
    this.modalMessage = data.data.modalMessage;
    this.sideMenuForm = this.fb.group({
      ams_side_menu_text: ['', Validators.required],
      ams_side_menu_order: ['', Validators.required],
      ams_side_menu_description: [''],
    });

    this.sideSubMenuForm = this.fb.group({
      ams_side_menu_id: ['', Validators.required],
      ams_side_sub_menu_text: ['', Validators.required],
      ams_side_sub_menu_page: [''],
      ams_side_sub_menu_icon: [''],
      ams_side_sub_menu_order: [''],
      ams_side_sub_sub_menu: [false, Validators.required],
      ams_side_sub_menu_description: [''],
    });

    this.sideSubSubMenuForm = this.fb.group({
      ams_side_sub_menu_id: ['', Validators.required],
      ams_side_sub_sub_menu_text: ['', Validators.required],
      ams_side_sub_sub_menu_page: ['', Validators.required],
      ams_side_sub_sub_menu_icon: ['', Validators.required],
      ams_side_sub_sub_menu_order: [''],
      ams_side_sub_sub_menu_description: [''],
    });
  }

  ngOnInit() {
    this.menuStateService.themeState$.subscribe((theme) => {
      this.themeMode = theme === 'ams-content-dark' ? 'dark' : 'light';
    });

    this.http.get('/api/menu_manager/menu_manager.php', { params: { type: 'menu' } }).subscribe((response: any) => {
      this.parentSubMenu = (response ?? []).map((menuItem: any) => {
        return { id: menuItem.ams_side_menu_id, text: menuItem.ams_side_menu_text };
      });
    });

    this.http.get('/api/menu_manager/menu_manager.php', { params: { type: 'subMenuWithSubSubMenu' } }).subscribe((response: any) => {
      this.parentSubSubMenu = (response ?? []).map((subMenuItem: any) => {
        return { id: subMenuItem.ams_side_sub_menu_id, text: subMenuItem.ams_side_sub_menu_text };
      });
    });
  }

  addNewSideMenu() {
    this.submitForm('addMenu', this.sideMenuForm, 'Menu item added.');
  }

  addNewSideSubMenu() {
    this.submitForm('addSubMenu', this.sideSubMenuForm, 'Sub-menu item added.');
  }

  addNewSideSubSubMenu() {
    this.submitForm('addSubSubMenu', this.sideSubSubMenuForm, 'Nested menu item added.');
  }

  closeModal() {
    this.dialogRef.close();
  }

  private submitForm(type: string, form: FormGroup, successMessage: string) {
    this.errorMessage = '';

    if (form.invalid) {
      form.markAllAsTouched();
      this.errorMessage = 'Fill out the required fields.';
      return;
    }

    this.saving = true;

    this.http.post('/api/menu_manager/menu_manager.php', {
      type,
      ...form.value,
    }).subscribe({
      next: () => {
        this.saving = false;
        this.toastr.success(successMessage);
        this.dialogRef.close({ saved: true });
      },
      error: (error) => {
        this.saving = false;
        this.errorMessage = error?.error?.message || 'Unable to save menu item.';
        this.toastr.error(this.errorMessage);
      }
    });
  }
}
